import { ApiCredits } from './ApiCredits';

interface CreditsTabProps {
  paymentStatus?: string | null;
}

export function CreditsTab({ paymentStatus }: CreditsTabProps) {
  return (
    <div className="space-y-6">
      <div>
        <h2 className="text-xl font-semibold text-gray-900 dark:text-gray-100 mb-4">
          API Credits & Usage
        </h2>
        <p className="text-gray-600 dark:text-gray-400">
          Monitor your API usage and manage credits for developer access.
        </p>
      </div>

      {paymentStatus === 'success' && (
        <div className="bg-green-50 dark:bg-green-900/20 border border-green-200 dark:border-green-800 rounded-lg p-4">
          <div className="flex items-center">
            <div className="flex-shrink-0">
              <svg
                className="h-5 w-5 text-green-400"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 20 20"
                fill="currentColor"
              >
                <path
                  fillRule="evenodd"
                  d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
                  clipRule="evenodd"
                />
              </svg>
            </div>
            <div className="ml-3">
              <h3 className="text-sm font-medium text-green-800 dark:text-green-200">
                Payment Successful
              </h3>
              <p className="text-sm text-green-700 dark:text-green-300 mt-1">
                Your payment has been processed successfully. Your credits will be updated shortly.
              </p>
            </div>
          </div>
        </div>
      )}

      <ApiCredits />
    </div>
  );
}
